import { ChangeDetectionStrategy, Component } from '@angular/core';
import { NzModalRef } from 'ng-zorro-antd';

@Component({
  selector: 'app-feature-access-denied-modal',
  templateUrl: './feature-access-denied.modal.html',
  styleUrls: ['./feature-access-denied.modal.less'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FeatureAccessDeniedModal {
  constructor(private readonly _nzModalRef: NzModalRef) {}

  public closeModal(): void {
    this._nzModalRef.close();
  }
}
